"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7329],{

/***/ 7329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ FlightStatusPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4250);
/* harmony import */ var _utils_Constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4953);
/* harmony import */ var _FlightStatus__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/**
 * Flight Status page wrapper (MMT only).
 * URL: /flights/{airline_url_phrase}/{flight_code}-flight-status.html
 * Layout: header full width; main content left (col-lg-9), blocks right (col-lg-3) like CityDT.
 */ 






function getInitialFormData(data) {
    var flightCode = (data === null || data === void 0 ? void 0 : data.flight_code) || "";
    var airlineDisplay = flightCode.replace(/_/g, " ").toUpperCase();
    var today = new Date().toISOString().slice(0, 10);
    return {
        FROM: null,
        TO: null,
        AIRPORT: null,
        AIRLINE: airlineDisplay,
        DATE: today,
        selectedOption: _FlightStatus__WEBPACK_IMPORTED_MODULE_4__/* .FLIGHT_SEARCH_TYPE_OPTIONS.BY_FLIGHT */ .Wj.BY_FLIGHT
    };
}
function FlightStatusPage(props) {
    var data = (props || {}).data;
    var pageData = (data === null || data === void 0 ? void 0 : data.pageData) || data || {};
    var ref;
    var fisStatus = (ref = data === null || data === void 0 ? void 0 : data.fisStatus) !== null && ref !== void 0 ? ref : pageData.fisStatus;
    var ref1;
    var airlineDetails = (ref1 = data === null || data === void 0 ? void 0 : data.airlineDetails) !== null && ref1 !== void 0 ? ref1 : pageData.airlineDetails;
    var ref2, ref3;
    var urlAttributeAirline = (ref3 = (ref2 = data === null || data === void 0 ? void 0 : data[_utils_Constants__WEBPACK_IMPORTED_MODULE_3__/* .URL_ATTRIBUTE_AIRLINE */ .R1q]) !== null && ref2 !== void 0 ? ref2 : pageData[_utils_Constants__WEBPACK_IMPORTED_MODULE_3__/* .URL_ATTRIBUTE_AIRLINE */ .R1q]) !== null && ref3 !== void 0 ? ref3 : data === null || data === void 0 ? void 0 : data.airline_url_phrase;
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var middleBlockHtml = "".concat((data === null || data === void 0 ? void 0 : data.contentTop) ? data.contentTop : "").concat((data === null || data === void 0 ? void 0 : data.contentMiddle) ? data.contentMiddle : "").concat((data === null || data === void 0 ? void 0 : data.content) ? data.content : "").concat((data === null || data === void 0 ? void 0 : data.contentBottom) ? data.contentBottom : "").concat((data === null || data === void 0 ? void 0 : data.bottomBlock) ? data.bottomBlock : "");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var container = containerRef.current;
        if (!container) return;
        var buttons = container.querySelectorAll(".ViewFareBtn");
        buttons === null || buttons === void 0 ? void 0 : buttons.forEach(function(button) {
            var url = button.getAttribute("data-url");
            if (url) {
                button.onclick = function() {
                    return window.location.replace(url);
                };
            }
        });
        // Wire carousel for top_airline_flight_status block (prev/next/dots)
        container.querySelectorAll("[id^='topAirlineFlightStatus_']").forEach(function(wrapper) {
            var slides = wrapper.querySelectorAll(".fsCarouselSlide");
            var dots = wrapper.querySelectorAll(".fsCarouselDot");
            var prev = wrapper.querySelector(".fsCarouselPrev");
            var next = wrapper.querySelector(".fsCarouselNext");
            var totalSlides = slides.length;
            if (totalSlides <= 1) return;
            var setButtonState = function(btn, disabled) {
                if (!btn) return;
                btn.disabled = disabled;
                btn.setAttribute("aria-disabled", String(disabled));
                btn.style.opacity = disabled ? "0.5" : "1";
                btn.style.color = disabled ? "#9aa0a6" : "#5f6368";
                btn.style.cursor = disabled ? "not-allowed" : "pointer";
            };
            var go = function(s) {
                slides.forEach(function(el, i) {
                    el.style.display = i === s ? "grid" : "none";
                });
                dots.forEach(function(el, i) {
                    el.style.background = i === s ? "#1a73e8" : "#dadce0";
                });
                setButtonState(prev, s === 0);
                setButtonState(next, s === totalSlides - 1);
                wrapper.setAttribute("data-cur", String(s));
            };
            if (prev) prev.onclick = function() {
                var s = Math.max(0, parseInt(wrapper.getAttribute("data-cur") || "0", 10) - 1);
                go(s);
            };
            if (next) next.onclick = function() {
                var s = Math.min(totalSlides - 1, parseInt(wrapper.getAttribute("data-cur") || "0", 10) + 1);
                go(s);
            };
            dots.forEach(function(d, i) {
                d.onclick = function() {
                    return go(i);
                };
            });
            go(0);
        });
    }, [
        middleBlockHtml
    ]);
    // Before passing, make sure the string has data-url instead of onclick
    var sanitizedHtml = middleBlockHtml.replace(/onclick="[^"]*"/, "");
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        return getInitialFormData(data);
    }), formData = ref4[0], setFormData = ref4[1];
    var flightStatusHeaderData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!data) return null;
        var ref;
        return {
            searchOptions: undefined,
            cta: {
                text: "Check Status"
            },
            meta: (ref = fisStatus === null || fisStatus === void 0 ? void 0 : fisStatus.meta) !== null && ref !== void 0 ? ref : {
                maxSelectablePastDays: 7,
                maxSelectableFutureDays: 30
            },
            defaultSearchOption: _FlightStatus__WEBPACK_IMPORTED_MODULE_4__/* .FLIGHT_SEARCH_TYPE_OPTIONS.BY_FLIGHT */ .Wj.BY_FLIGHT
        };
    }, [
        data,
        fisStatus === null || fisStatus === void 0 ? void 0 : fisStatus.meta
    ]);
    var detailData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref;
        var title = (ref = fisStatus === null || fisStatus === void 0 ? void 0 : fisStatus.title) !== null && ref !== void 0 ? ref : data === null || data === void 0 ? void 0 : data.title;
        var ref1;
        var disclaimer = (ref1 = fisStatus === null || fisStatus === void 0 ? void 0 : fisStatus.disclaimer) !== null && ref1 !== void 0 ? ref1 : data === null || data === void 0 ? void 0 : data.description;
        if (!title && !disclaimer && !(fisStatus === null || fisStatus === void 0 ? void 0 : fisStatus.cardsData)) return null;
        var ref2, ref3;
        return {
            title: title !== null && title !== void 0 ? title : null,
            disclaimer: disclaimer !== null && disclaimer !== void 0 ? disclaimer : null,
            shareCta: (ref2 = fisStatus === null || fisStatus === void 0 ? void 0 : fisStatus.shareCta) !== null && ref2 !== void 0 ? ref2 : null,
            cardsData: (ref3 = fisStatus === null || fisStatus === void 0 ? void 0 : fisStatus.cardsData) !== null && ref3 !== void 0 ? ref3 : null
        };
    }, [
        fisStatus,
        data === null || data === void 0 ? void 0 : data.title,
        data === null || data === void 0 ? void 0 : data.description
    ]);
    var handleSearch = function() {
        var fromCode = (data === null || data === void 0 ? void 0 : data.flightStatusFromCode) || "";
        var toCode = (data === null || data === void 0 ? void 0 : data.flightStatusToCode) || "";
        var airportCode = (data === null || data === void 0 ? void 0 : data.flightStatusAirportCode) || fromCode;
        var airlineParam = (formData.AIRLINE || "").replace(/\s+/g, "");
        var dateParam = formData.DATE || new Date().toISOString().slice(0, 10);
        var params = new URLSearchParams({
            from: fromCode,
            to: toCode,
            airport: airportCode,
            airline: airlineParam,
            date: dateParam,
            selectedOption: "byFlight",
            crId: (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .getCrId */ .N1)()
        });
        var detailUrl = "https://www.makemytrip.com/flight/flight-status/detail?".concat(params.toString());
        if (true) {
            window.location.href = detailUrl;
        }
    };
    var logEvent = function() {};
    var clearRefreshTimer = function() {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flight-status-page-wrapper flight-status-page",
        children: [
            flightStatusHeaderData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pageStickyHder flight-status-search",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FlightStatus__WEBPACK_IMPORTED_MODULE_4__/* .FlightStatusHeader */ .cV, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, flightStatusHeaderData), {
                    onSearch: handleSearch,
                    formData: formData,
                    setFormData: setFormData
                }))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fli-intl-container prepend_top20 clearfix listingContainer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "makeCenterCol clearfix noPadding",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "makeRelative padding10",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "bgGradient",
                                    "aria-hidden": true
                                }),
                                detailData ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "fsd-content-wrap",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FlightStatus__WEBPACK_IMPORTED_MODULE_4__/* .FlightStatusDetail */ .tZ, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, detailData), {
                                        logEvent: logEvent,
                                        clearRefreshTimer: clearRefreshTimer,
                                        h1Header: data === null || data === void 0 ? void 0 : data.h1Header
                                    }))
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            id: "seoContentMiddle",
                            className: "fsd-seo-content-middle seoOnlyBlock",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                ref: containerRef,
                                children: (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .transformToHtml */ .cR)(sanitizedHtml)
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            id: "seoRightBlock",
                            className: "seoOnlyBlock col-lg-3 col-md-12 col-sm-12 col-xs-12 airline-right-container nopadding-mob paddR0 ",
                            children: [
                                (data === null || data === void 0 ? void 0 : data.filterBlock) && (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .transformToHtml */ .cR)(data === null || data === void 0 ? void 0 : data.filterBlock),
                                (data === null || data === void 0 ? void 0 : data.rightBlock) && (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .transformToHtml */ .cR)(data === null || data === void 0 ? void 0 : data.rightBlock),
                                (data === null || data === void 0 ? void 0 : data.leftBlock) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: data === null || data === void 0 ? void 0 : data.leftBlock
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


/***/ })

}]);